/* ───────────────────────────────────────────────────────────────────
   omi-hero-2026 — auto-rotating hero (gummies ⇄ capsules)

   • Toggles data-state on the section root every N ms (configured per
     instance via data-interval; default 3000).
   • Pauses when: prefers-reduced-motion, hover, focus inside, off-screen
     (IntersectionObserver), or tab hidden.
   • WCAG 2.2 SC 2.2.2 — exposes a Play/Pause button.
   • Built OOP-style so multiple instances on a page are safe even though
     the schema currently uses limit: 1.
   ─────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var STATES = ['gummies', 'capsules'];
  var ANNOUNCE = {
    gummies:  'Now showing Hair Growth Peptides Gummies.',
    capsules: 'Now showing Hair Growth Peptides Capsules.'
  };

  function OmiHero2026(root) {
    if (!root || root._omiHero2026) return;
    root._omiHero2026 = this;

    this.root      = root;
    this.live      = root.querySelector('[data-omi-hero-2026-live]');
    this.ppBtn     = root.querySelector('[data-omi-hero-2026-playpause]');
    this.interval  = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    this.timer     = null;
    this.playing   = false;
    this.reduce    = window.matchMedia &&
                     window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.bind();
    this.observe();

    if (!this.reduce) this.start();
  }

  OmiHero2026.prototype.next = function () {
    var current = this.root.getAttribute('data-state') || STATES[0];
    var idx     = STATES.indexOf(current);
    var nextIdx = (idx + 1) % STATES.length;
    this.setState(STATES[nextIdx]);
  };

  OmiHero2026.prototype.setState = function (state) {
    if (STATES.indexOf(state) === -1) return;
    if (this.root.getAttribute('data-state') === state) return;
    this.root.setAttribute('data-state', state);
    if (this.live && ANNOUNCE[state]) {
      this.live.textContent = '';
      var live = this.live;
      var msg  = ANNOUNCE[state];
      requestAnimationFrame(function () { live.textContent = msg; });
    }
  };

  OmiHero2026.prototype.start = function () {
    if (this.reduce || this.timer) return;
    this.playing = true;
    this.updatePPBtn();
    var self = this;
    this.timer = setInterval(function () { self.next(); }, this.interval);
  };

  OmiHero2026.prototype.pause = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.playing = false;
    this.updatePPBtn();
  };

  OmiHero2026.prototype.togglePlay = function () {
    if (this.playing) {
      this.pause();
    } else {
      this.start();
    }
  };

  OmiHero2026.prototype.updatePPBtn = function () {
    if (!this.ppBtn) return;
    this.ppBtn.setAttribute('aria-pressed', String(this.playing));
    this.ppBtn.setAttribute(
      'aria-label',
      this.playing ? 'Pause hero slideshow' : 'Play hero slideshow'
    );
  };

  OmiHero2026.prototype.bind = function () {
    var self = this;

    if (this.ppBtn) {
      this.ppBtn.addEventListener('click', function () { self.togglePlay(); });
    }

    /* Pause on hover */
    this.root.addEventListener('mouseenter', function () {
      if (self.playing) self.pause();
    });
    this.root.addEventListener('mouseleave', function () {
      if (!self.reduce && !self.playing && self.inView !== false) self.start();
    });

    /* Pause when keyboard focus enters the hero */
    this.root.addEventListener('focusin', function () {
      if (self.playing) self.pause();
    });
    this.root.addEventListener('focusout', function (e) {
      if (!self.root.contains(e.relatedTarget) &&
          !self.reduce && !self.playing && self.inView !== false) {
        self.start();
      }
    });

    /* Pause when the tab is backgrounded (saves CPU + image work) */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (self.playing) self.pause();
      } else if (!self.reduce && self.inView !== false) {
        self.start();
      }
    });
  };

  OmiHero2026.prototype.observe = function () {
    if (!('IntersectionObserver' in window)) {
      this.inView = true;
      return;
    }
    var self = this;
    this.inView = true;
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.inView = entry.isIntersecting;
        if (entry.isIntersecting) {
          if (!self.reduce && !document.hidden) self.start();
        } else {
          self.pause();
        }
      });
    }, { threshold: 0.2 });
    this.io.observe(this.root);
  };

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-omi-hero-2026]')
      .forEach(function (el) { new OmiHero2026(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Shopify theme editor re-init on section load */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
}());
